import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvelopeStatusBadgeModule } from '../envelope-status-badge/envelope-status-badge.module';

import { SidebarEnvelopeDocumentComponent } from './sidebar-envelope-document.component';

@NgModule({
  imports: [CommonModule, EnvelopeStatusBadgeModule],
  declarations: [SidebarEnvelopeDocumentComponent],
  exports: [SidebarEnvelopeDocumentComponent]
})
export class SidebarEnvelopeDocumentModule {}
